module.exports = __webpack_public_path__ + "static/media/barre-fitness.52b8e206.jpg";